module.exports = __webpack_public_path__ + "img/banner-img-overlay.e47f0684.jpg";